"use client";

import styles from "@/search/page.module.css";

// A failed landing lookup (e.g. DB outage) lands here instead of a 404, so ISR
// keeps serving the last good page and never caches a "not found".
export default function LandingError() {
    return (
        <div className={styles.empty}>
            <h2 className={styles.emptyTitle}>Something went wrong</h2>
            <p className={styles.emptyText}>
                We couldn&apos;t load the cars right now — please try again in a moment.
            </p>
        </div>
    );
}
